import React from 'react';
import { Switch } from 'react-router-dom';
import { AppRouter } from '@revenuewell/logic-routing';
import { SignInRedirectRoutes } from './sign-in-redirect-routes';

/* eslint-disable-next-line */
export interface AuthAppProps {}

export function SignInCallback(props: AuthAppProps) {
    return (
        <Switch>
            <AppRouter routes={SignInRedirectRoutes} />
        </Switch>
    )
}
